
define('text!templates/parts/chart/pie-chart.html',[],function () { return '<div class="pie-chart">\n    <div class="chart-canvas"><div><canvas></canvas></div></div>\n</div>\n';});

